export const ActionTypes = {
  USER_DETAIL: "USER_DETAIL",
  USER_LOGGED_IN: "USER_LOGGED_IN",
};
